import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
	providedIn: 'root',
})
export class DataTransferService {
	constructor() {}
	private profileInfo: Subject<any> = new Subject<any>();

	emitProfileUpdate(data) {
		this.profileInfo.next(data);
	}

	profileUpdate() {
		return this.profileInfo.asObservable();
	}
}
